import Swal from 'sweetalert2';

export default function openMoleculasModal(molecula: any, barra: any, axios: any, apiRoute: any) {
    if (molecula === 'POR DEFINIR') {
        return;
    }

    const money2 = (n: any) => {
        const x = Number(n || 0);
        return x.toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const money4 = (n: any) => {
        const x = Number(n || 0);
        return x.toLocaleString('es-VE', { minimumFractionDigits: 4, maximumFractionDigits: 4 });
    };

    const chip = (txt: string) => `<span class="chip">${txt}</span>`;

    Swal.fire({
        allowOutsideClick: false,
        focusConfirm: false,
        didOpen: () => {
            Swal.showLoading();
            const token = localStorage.getItem(`authToken`);

            axios.get(`${apiRoute}/molecule-comparison`, {
                headers: { 'Authorization': `Bearer ${token}` },
                params: { molecula }
            })
                .then((response: any) => {
                    const payload = response?.data?.[0] || {};
                    const ordered_data = payload?.data || [];
                    const title = payload?.molecula || molecula;
                    const factor = Number(payload?.factor || 1);

                    const headerHtml = `
                        <div class="hdr">
                            <div class="hdr-left">
                                <div class="ttl">Comparativo de moléculas</div>
                                <div class="sub">Molécula: <b>${title}</b></div>
                                <div class="meta">
                                    ${chip(`Factor: ${money2(factor)}`)}
                                    ${chip(`Items: ${ordered_data.length}`)}
                                    ${barra ? chip(`Barra actual: ${barra}`) : ''}
                                </div>
                            </div>
                        </div>
                    `;

                    let html = `
                        <style>
                            .swal-wide { width: 1100px !important; }
                            .wrap { font-family: system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; color:#0f172a; }
                            .hdr { display:flex; align-items:center; justify-content:center; gap:12px; margin-bottom:12px; }
                            .ttl { font-size:16px; font-weight:800; }
                            .sub { font-size:13px; color:#334155; margin-top:2px; }
                            .meta { margin-top:8px; display:flex; flex-wrap:wrap; gap:6px; justify-content:center; }
                            .chip { display:inline-block; padding:4px 8px; border-radius:999px; font-size:12px; background:#f1f5f9; border:1px solid #e2e8f0; color:#0f172a; }
                            .legend { display:flex; gap:10px; margin:10px 0 8px; color:#475569; font-size:12px; }
                            .dot { width:10px; height:10px; border-radius:50%; display:inline-block; margin-right:6px; vertical-align:middle; }
                            .dot-min { background:#86efac; border:1px solid #22c55e; }
                            .dot-cur { background:#fecaca; border:1px solid #ef4444; }

                            .tableWrap { border:1px solid #e2e8f0; border-radius:12px; overflow:hidden; }
                            .scroll { max-height: 60vh; overflow:auto; }
                            table { width:100%; border-collapse:separate; border-spacing:0; }
                            thead th {
                                position: sticky; top: 0;
                                background:#0b63a6; color:#fff;
                                font-size:12px; text-align:left;
                                padding:10px 10px;
                                border-bottom:1px solid rgba(255,255,255,.2);
                                white-space:nowrap;
                                z-index:2;
                            }
                            tbody td {
                                font-size:12px; padding:10px 10px;
                                border-bottom:1px solid #eef2f7;
                                vertical-align:top;
                                white-space:nowrap;
                            }
                            tbody tr:nth-child(even) td { background:#f8fafc; }
                            tr.row-min td { background: #ecfdf5 !important; }
                            tr.row-cur td { background: #fff1f2 !important; }
                            tr.row-min.row-cur td { background: linear-gradient(90deg, #ecfdf5, #fff1f2) !important; }

                            .num { text-align:right; }
                            .muted { color:#64748b; font-size:11px; margin-top:2px; }
                            .moneyCell { line-height:1.15; }
                            .moneyTop { font-weight:700; }
                            .moneyBottom { color:#64748b; font-size:11px; margin-top:3px; }
                            .badge { display:inline-block; padding:2px 8px; border-radius:999px; font-size:11px; border:1px solid #e2e8f0; background:#fff; }
                            .bmin { border-color:#22c55e; color:#166534; background:#ecfdf5; }
                            .bcur { border-color:#ef4444; color:#991b1b; background:#fff1f2; }
                        </style>

                        <div class="wrap">
                            ${headerHtml}
                            <div class="legend">
                                <span><span class="dot dot-min"></span>Mejor costo molécula</span>
                                <span><span class="dot dot-cur"></span>Tu barra</span>
                            </div>

                            <div class="tableWrap">
                                <div class="scroll">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th style="width:40px">#</th>
                                                <th>Marca</th>
                                                <th>Barra</th>
                                                <th class="num">Costo</th>
                                                <th class="num">Unidad</th>
                                                <th class="num">Costo molécula</th>
                                                <th style="width:110px">Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                    `;

                    ordered_data.forEach((element: any, idx: number) => {
                        const isMin = !!element.min_price;
                        const isCur = String(element.barra) === String(barra);

                        const rowClass = `${isMin ? 'row-min' : ''} ${isCur ? 'row-cur' : ''}`.trim();

                        const costoBs = Number(element.costo || 0);
                        const costoUsd = Number(element.costo_usd || (factor > 0 ? costoBs / factor : 0));

                        const pmBs = Number(element.precio_molecula || 0);
                        const pmUsd = Number(element.precio_molecula_usd || (factor > 0 ? pmBs / factor : 0));

                        const estadoBadges = `
                            ${isMin ? `<span class="badge bmin">MIN</span>` : ''}
                            ${isCur ? `<span class="badge bcur" style="margin-left:6px;">ACTUAL</span>` : ''}
                        `;

                        html += `
                            <tr class="${rowClass}">
                                <td>${idx + 1}</td>
                                <td>${element.marca ?? ''}</td>
                                <td>${element.barra ?? ''}</td>

                                <td class="num moneyCell">
                                    <div class="moneyTop">Bs ${money2(costoBs)}</div>
                                    <div class="moneyBottom">$ ${money2(costoUsd)}</div>
                                </td>

                                <td class="num">${Number(element.unidadmolecula || 1).toLocaleString('es-VE')}</td>

                                <td class="num moneyCell">
                                    <div class="moneyTop">Bs ${money2(pmBs)}</div>
                                    <div class="moneyBottom">$ ${money2(pmUsd)}</div>
                                </td>

                                <td>${estadoBadges || '<span class="muted">—</span>'}</td>
                            </tr>
                        `;
                    });

                    html += `
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    `;

                    Swal.fire({
                        title: '',
                        html,
                        showCloseButton: true,
                        showConfirmButton: false,
                        focusConfirm: false,
                        customClass: { popup: 'swal2-popup swal2-modal swal2-show swal-wide' }
                    });
                })
                .catch((error: any) => {
                    const errorMessage = error.response ? (error.response.data?.message ?? JSON.stringify(error.response.data)) : 'La petición falló.';
                    Swal.fire({
                        focusConfirm: false,
                        title: 'Error',
                        text: errorMessage,
                        icon: 'error',
                        showConfirmButton: true
                    });
                });
        }
    });
}
